import {convertEditorStateToHtml, convertHtmlToEditorState} from '../../../../helpers/formik';

export const Normalizer = {
  fetch: data => {
    return {
      ...data,
      fields: {
        ...data.fields,
        Name: data.fields.Name || '',
        Subject: data.fields.Subject || '',
        Message: convertHtmlToEditorState(data.fields.Message || ''),
        attachments: data.fields.attachments
          ? data.fields.attachments.map(f => ({
              id: f.id,
              isUploaded: true,
              file: { name: f.name, size: f.size },
            }))
          : [],
        attachSize:
          data.fields.attachments && data.fields.attachments.length
            ? data.fields.attachments.reduce(
                (sum, a) => sum + Number(a.size),
                0
              )
            : 0,
      },
    };
  },

  fetchFile: data => ({
    id: data.id,
    isUploaded: true,
    file: { name: data.name, size: data.size },
  }),

  send: values => {
    const params = {};
    Object.keys(values)
      .filter(
        k => values[k] !== null && k !== 'attachSize' && k !== 'attachments'
      )
      .forEach(k => {
        if (k === 'Message') {
          params[k] = convertEditorStateToHtml(values[k]);
        } else {
          params[k] = values[k];
        }
      });

    return params;
  },
};
